import * as React from 'react';

export interface ButtonExternalLinkProps {
    children: React.ReactNode;
    onClick: Function;
}

const ButtonExternalLink = ({
    children,
    variant,
    onClick,
    ...restProps
}: ButtonExternalLinkProps & any) => {
    const variantClass = variant ? `rw-reply-${variant}` : '';

    return (
        <a
            className={`rw-reply ${variantClass} rw-button-link`}
            rel="noopener noreferrer"
            onClick={(e) => {
                e.stopPropagation();
                onClick && onClick(e);
            }}
            onMouseUp={(e) => e.stopPropagation()}
            {...restProps}
        >
            {children}
            <svg
                className="reply-icon filled"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.83333 3C3.37281 3 3 3.37281 3 3.83333V12.1667C3 12.6272 3.37281 13 3.83333 13H12.1667C12.6272 13 13 12.6272 13 12.1667V8.33333H14V12.1667C14 13.1795 13.1795 14 12.1667 14H3.83333C2.82052 14 2 13.1795 2 12.1667V3.83333C2 2.82052 2.82052 2 3.83333 2H7.66667V3H3.83333ZM12.2929 3H9V2H13.1667C13.6261 2 14 2.37386 14 2.83333V7H13V3.70711L7.52022 9.18689L6.81311 8.47978L12.2929 3Z"
                    fill="#1F1F1F"
                />
            </svg>
        </a>
    );
};

export default ButtonExternalLink;
